module.exports = __webpack_public_path__ + "static/img/132a8fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/qhRecommendOpenAccount/images/success.png
// module id = 680
// module chunks = 2